import * as React from 'react';
import { useTranslation } from '@omilia/providers';
import Spinner from '@omilia/spinner';
import AgentWarning from '../components/AgentWarning';

const AgentConnectingNotification = () => {
  const { t } = useTranslation();

  return (
    <AgentWarning
      dataTest="agent-connecting-notification"
      icon={<Spinner color="warning" />}
      title={t('messages.connectingToAgent')}
      description={t('messages.pleaseWait')}
    />
  );
};

export default AgentConnectingNotification;
